import type {LayoutPayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {sidebarAboutQuery} from '../queries/sidebar-about-query'

export const codeViewLayoutRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewLayoutRoute', {
  path: '/:owner/:repo',
  queries: [
    mainQuery<LayoutPayload>({
      queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
    }),
    sidebarAboutQuery,
  ],
  shouldRevalidate: ({currentParams, nextParams}) => {
    return currentParams.owner !== nextParams.owner || currentParams.repo !== nextParams.repo
  },
})
